import { Flex, Link as BPLink } from '@resideo/blueprint-react';
import styled, { css } from 'styled-components';

const containerStyle = css`
  margin-bottom: 32px;
  flex-direction: column;
`;

export const ContainerDesktop = styled(Flex)`
  ${containerStyle}
  max-width: 800px;
`;

export const ContainerMobile = styled(Flex)`
  ${containerStyle}
  font-size: 18px;
`;

export const Content = styled(Flex)`
  justify-content: space-between;
`;

export const FieldTitle = styled.p`
  font-weight: bold;
  margin: 0;
  margin-bottom: 16px;
`;

export const FieldText = styled.p`
  margin: 0;
  margin-right: 40px;
  flex-shrink: 10;
  overflow-wrap: break-word;
`;

export const Link = styled(BPLink)`
  font-size: medium;
  font-weight: 500;
  margin-bottom: 16px;
  text-transform: uppercase;
  text-decoration: underline;
  :hover,
  :focus {
    color: #004266;
  }
`;
